import React from 'react';
import {twMerge} from 'tailwind-merge';
import LinearText from '../linear-text/linear-text';
import LinearImage from '../linear-image/linear-image';

interface MerchandiseItem {
    src: string;
    alt: string;
    width: number;
    height: number;
}

interface MerchandiseSectionProps {
    merchandiseItems: MerchandiseItem[];
    title?: string;
    mainItem: string;
    titleClassName?: string;
    mainItemClassName?: string;
    merchandiseItemClassName?: string;
}

export const MerchandiseSection: React.FC<MerchandiseSectionProps> = ({
    merchandiseItems,
    title = 'MERCHANDISE',
    mainItem,
    titleClassName,
    mainItemClassName,
    merchandiseItemClassName,
}) => {
    const titleStyle = twMerge(`!font-montserrat text-[36px] xxs:text-[24px] md:text-[48px] font-bold`, titleClassName);
    const mainItemStyle = twMerge(`w-full max-w-[686px] shrink-0 hidden md:block md:h-[420px] h-[430px]`, mainItemClassName);
    const merchandiseItemStyle = twMerge(
        `max-w-[377px] w-full h-[200px] cursor-pointer p-5 rounded-0`,
        merchandiseItemClassName,
    );

    return (
        <section className="w-full max-w-[1200px] my-6 md:my-[80px] rounded-xl px-4 xl:!px-0">
            <div className="flex flex-col lg:flex-row justify-between items-start gap-6 md:gap-4">
                {/* Left content */}
                <div>
                    <LinearText as={'h3'} className={titleStyle}>
                        {title}
                    </LinearText>
                    <p className="mt-2 text-black text-sm md:text-lg font-montserrat">
                        Bộ Quà tặng độc quyền của <span className="font-bold">"Vươn Concert"</span>, hứa hẹn sẽ mang lại cho bạn một đêm bùng cháy. Hàng ngàn khán giả hòa chung nhịp đập, sống trọn trong không khí cuồng nhiệt và thỏa sức cháy hết mình.
                    </p>
                </div>

                {/* Main tote image */}
                <div className={mainItemStyle}>
                    <LinearImage
                        src={mainItem}
                        alt="Túi Tote Tổ Quốc"
                        className="w-full h-full"
                        width={572}
                        height={255}
                        imageContainerClassName='w-full h-full p-5'
                        imageClassName='object-contain'
                    />
                </div>
            </div>

            {/* Merchandise items */}
            <div className="w-full flex md:flex-row flex-col md:justify-start justify-center items-center gap-9 md:mt-6 mt-4">
                {merchandiseItems?.map(item => (
                    <LinearImage
                        key={item.src}
                        src={item.src}
                        alt={item.alt}
                        width={item.width}
                        height={item.height}
                        className={merchandiseItemStyle}
                        imageClassName='object-contain'
                    />
                ))}
            </div>
        </section>
    );
};
